import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
/* import Button from "@mui/material/Button"; */
import SonabelLogo from "../../../assets/Sonabel_logo.svg.jpg";
import HomeIcon from "@mui/icons-material/Home";
import { api } from "../../../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* import { CircularProgress } from "@mui/material"; */
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { MuiTelInput } from "mui-tel-input";
import { UICard } from "../ui/UICard";
import { UITextInput } from "../ui/UITextInput";
import { UIButton } from "../ui/UIButton";
import { UISpinner } from "../ui/UISpinner";
import { UILabel } from "../ui/UILabel";

const Login = () => {
  const navigate = useNavigate();

  // utiliser useState pour sauvegarder les saisies de l'utilisateur
  /*  const [email, setEmail] = useState(""); */
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+226");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const telephone = phoneNumber.replace(/\s+/g, "");
    try {
      setLoading(true);
      api
        .post("/account/login", { email: telephone, password: password })
        .then((response) => {
          if (response.data.status === 200) {
            localStorage.setItem("isConnected", true);
            localStorage.setItem(
              "accessToken",
              response?.data?.content.sessionKey
            );
            localStorage.setItem(
              "userId",
              response.data.content.user.accountId
            );
            localStorage.setItem(
              "username",
              response.data.content.user.fullName
            );
            localStorage.setItem("email", response.data.content.user.email);
            localStorage.setItem(
              "phoneNumber",
              response.data.content.user.phoneNumber
            );
            //setEmail("");
            setPassword("");
            setLoading(false);
            //Rédiriger vers la page d'accueil
            navigate("/dashboard");
          }
        })
        .catch((err) => {
          setLoading(false);
          if (!err?.response) {
            toast.warning("Pas de réponse du serveur");
          } else if (err.response?.status === 400) {
            toast.warning("Email ou mot de passe manquant");
          } else if (err.response?.status === 401) {
            toast.warning("Votre mot de passe ou email est incorrect.");
          } else {
            toast.warning("Echec de l'authentification");
          }
          localStorage.clear();
        });
    } catch (err) {}
  };

  // Contrôler le changement d'état de l'input telephone
  const handleChangePhone = (value) => {
    setPhoneNumber(value);
  };

  return (
    <main>
      <section className="bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <Link
            to="/"
            className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
          >
            <img className="w-50 h-12 mr-2" src={SonabelLogo} alt="logo" />
            SONABEL
          </Link>
          <ToastContainer />
          {/*  <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"> */}
          <UICard className="w-full md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                Connectez-vous à votre compte
              </h1>
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                {/*  <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="votre email"
                    required
                  />
                </div> */}
                <div>
                  <label
                    htmlFor="phoneNumber"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Numéro de Téléphone
                  </label>
                  <MuiTelInput
                    fullWidth
                    size="small"
                    value={phoneNumber}
                    onChange={handleChangePhone}
                    placeholder="Votre numéro de téléphone"
                    required
                    autoComplete="tel"
                    sx={{
                      backgroundColor: "rgb(249 250 251)", // bg-gray-50
                      borderColor: "rgb(209 213 219)", // border-gray-300
                      color: "rgb(17 24 39)", // text-gray-900
                      fontSize: "0.875rem", // text-sm
                      borderRadius: "0.5rem", // rounded-lg
                      // Ciblez la racine de l'OutlinedInput pour les styles de bordure/focus
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          // Ciblez la bordure (fieldset) de l'input
                          borderColor: "rgb(209 213 219)",
                        },
                        "&:hover fieldset": {
                          // État survol pour la bordure
                          borderColor: "rgb(209 213 219)",
                        },
                        "&.Mui-focused fieldset": {
                          // État de focus pour la bordure
                          borderColor: "rgb(14, 159, 10)", // focus:border-green-500 (ajustez à votre vert-500)
                          boxShadow: "0 0 0 0px rgb(14, 159, 10)", // focus:ring-green-500 (ajustez)
                        },
                      },
                      // Ciblez l'élément input réel pour le padding

                      "& .MuiInputBase-input": {
                        padding: "0.625rem 0.75rem",
                        // p-2.5 (ajustez si nécessaire, MUI a un padding par défaut)
                      },
                      // Styles pour l'état désactivé
                      "&.Mui-disabled": {
                        backgroundColor: "rgb(229 231 235)", // disabled:bg-gray-200
                        color: "rgb(107 114 128)", // disabled:text-gray-500
                      },
                      display: "block", // block
                      width: "100%", // w-full
                      // Supprimez aussi l'outline sur le composant racine
                    }}
                  />
                </div>
                <div>
                  <UILabel
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Mot de passe
                  </UILabel>
                  <div className="relative">
                    {/*     <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder="*********"
                      autoComplete="current-password"
                      className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                    /> */}

                    <UITextInput
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder="*********"
                      autoComplete="current-password"
                      required
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="remember"
                        aria-describedby="remember"
                        type="checkbox"
                        className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-green-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-green-600 dark:ring-offset-gray-800 checked:bg-green-500 checked:border-green-500 checked:hover:bg-green-600 checked:hover:border-green-600 checked:focus:bg-green-500 checked:focus:border-green-500"
                        required=""
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label
                        htmlFor="remember"
                        className="text-gray-500 dark:text-gray-300"
                      >
                        Remember me
                      </label>
                    </div>
                  </div>
                  {/*  <Link
                    to="/reset_password"
                    className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                  >
                    Mot de passe oublié?
                  </Link> */}
                  <Link
                    to="/oublie_password"
                    className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                  >
                    Mot de passe oublié?
                  </Link>
                </div>
                {/*   <Button
                  type="submit"
                  className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                >
                  {loading ? (
                    <>
                      <CircularProgress color="primary" size="1rem" />
                      En cours ...
                    </>
                  ) : (
                    <>Se connecter</>
                  )}
                </Button> */}

                <UIButton type="submit" variant="primary">
                  {loading ? (
                    <div className="flex items-center justify-center">
                      <UISpinner className="mr-2" /> EN cours...
                    </div>
                  ) : (
                    "Se Connecter"
                  )}
                </UIButton>
                <div className="flex flex-row justify-around">
                  <div>
                    <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                      Vous n'avez pas encore de compte ? {""}
                      <Link
                        to="/register"
                        className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                      >
                        Inscrivez-vous
                      </Link>
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                      <Link
                        to="/"
                        className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                      >
                        <HomeIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
            {/*  </div> */}
          </UICard>
        </div>
      </section>
    </main>
  );
};

export default Login;
